<script>
import { debounce } from "lodash";
import RawData from "@/components/widgets/raw-data.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
export default {
    props: {
        itemData: {
            type: Object,
            default: null,
        },
    },
    components: {
        RawData,
        MaskedInput,
    },
    data(){
        return {
            sortBy: "id",
            sortDesc: false,
            fields: [
                {
                    key: "select",
                    label: "",
                    thStyle: { width: "50px" }
                },
                {
                    key: "stockNumber",
                    sortable: true,
                    label: "Stock Number"
                },
                {
                    key: "name",
                    sortable: true,
                    label: "Stock Name"
                },
                {
                    key: "unit",
                    sortable: false,
                    label: "Unit"
                },
                {
                    key: "available",
                    sortable: false,
                    label: "Current Balance",
                    thStyle: { width: "150px" },
                    tdClass: "text-center v-align-middle"
                },
                {
                    key: "onHand",
                    sortable: false,
                    label: "On Hand Balance",
                    thStyle: { width: "150px" },
                    tdClass: "text-center v-align-middle"
                },
                {
                    key: "actions",
                    sortable: false,
                    label: "Actions",
                    thStyle: { width: "120px" },
                    thClass: "text-center",
                    tdClass: "text-center"
                }
            ],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
        }
    },
    computed: {
        filtered() {
            if(!this.itemData || !this.itemData.stockItems) return [];
            let data = this.itemData.stockItems;
            if (this.itemData.searchInput.trim() != "" && this.itemData.searchInput) {
                data = data.filter((item) => {
                const searchTerm = this.itemData.searchInput.toUpperCase();
                    return (
                        item.stockItemName.toUpperCase().includes(searchTerm) ||
                        item.stockNumber.toUpperCase().includes(searchTerm) ||
                        item.description.toUpperCase().includes(searchTerm)
                    );
                });
            }
            return data;
        },
        rows() {
            return this.filtered.length;
        },
        isAllSelected: {
            get() {
                return this.filtered.length > 0 && this.filtered.every(item => item.selected);
            },
            set(value) {
                this.filtered.forEach(item => {
                    item.selected = value;
                });
            }
        },
        selectedItems() {
            return this.filtered.filter(item => item.selected);
        }
    },
    methods: {
        delayFilter: debounce(function () {
            this.itemData.filter = this.itemData.searchInput;
            this.itemData.currentPage = 1;
            this.itemData.tableBusy = false;
        }, 600),
        deleteItems(items) {
            this.$swal({
                title: "Are you sure?",
                text: "You are about to delete this stock items?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let ids = items.map(item => item.id);
                    this.$store
                        .dispatch("stock/RemoveInventoryStockItem", ids)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.itemData.stockItems = this.itemData.stockItems.filter(item => !ids.includes(item.id));
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                        this.showToast("Cannot be deleted!", "error");
                    });
                }
            });
        },
        beforeUpdate(item) {
            item.balancePerCardCopy = JSON.parse(JSON.stringify(item.balancePerCard)).toString();
            item.onHandPerCountCopy = JSON.parse(JSON.stringify(item.onHandPerCount)).toString();
            item.isUpdate = true;
        },
        updateItem(item) {
            let data = JSON.parse(JSON.stringify(item));
            data.balancePerCard = this.getExactAmt(item.balancePerCardCopy);
            data.onHandPerCount = this.getExactAmt(item.onHandPerCountCopy);
            this.$emit('update-item', data);
        },
    },
}
</script>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mt-2">
            <div class="d-flex gap-1">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input
                            autocomplete="off"
                            @keyup="itemData.tableBusy = true; delayFilter();"
                            v-model="itemData.searchInput"
                            type="search"
                            placeholder="Search Stock..."
                            class="form-control form-control-sm w-300px"
                        ></b-form-input>
                    </label>
                </div>
                <div>
                    <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                        class="form-select form-select-sm"
                        v-model="itemData.perPage"
                        size="sm"
                        :options="pageOptions"
                        >
                        </b-form-select>
                    </label>
                </div>
                <div>
                    <button type="button" class="btn btn-sm btn-outline-info" @click="$emit('view-members')">
                        <i class="bx bx-user"></i> View Committee Members
                    </button>
                </div>
            </div>
            <div class="d-flex gap-1 align-items-center">
                <button type="button" class="btn btn-danger btn-sm" v-if="selectedItems.length" @click="deleteItems(selectedItems)"><i class="bx bx-trash"></i> Remove Selected ({{ selectedItems.length }})</button>
                <button type="button" class="btn btn-success btn-sm" @click="$emit('add-stock')"><i class="bx bx-plus"></i> Add Stock</button>
                <button type="button" class="btn btn-purple btn-sm" @click="$emit('print-rpci')"><i class="bx bx-printer"></i> Print RPCI</button>
            </div>
        </div>
        <div class="custom-table-responsive mb-0 mt-2 border-top">
            <b-table
                :items="filtered"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :busy="itemData.tableBusy"
                striped
                hover
                responsive
                show-empty
                empty-text="No stocks found"
            >
                <!-- Select All Checkbox -->
                <template #table-busy>
                    <div class="d-flex justify-content-center gap-1">
                        <b-spinner small></b-spinner>
                        <span class="ms-1">Loading...</span>
                    </div>
                </template>
                <template #head(select)>
                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="isAllSelected"
                        />
                    </div>
                </template>
                <template #cell(select)="data">
                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="data.item.selected"
                    />
                    </div>
                </template>
                <template #cell(stockNumber)="data">
                    <div class="position-relative">
                        <RawData :data="data.item" v-if="$store.state.decrypt.isAdmin()" />
                        <p class="mb-0">{{data.value}}</p>
                    </div>
                </template>
                <template #cell(name)="data">
                    <div>
                        {{data.item.stockItemName}}
                        <small class="d-block"><i>{{data.item.description}}</i></small>
                    </div>
                </template>
                <template #cell(available)="data">
                    <template v-if="data.item.isUpdate">
                        <form @submit.prevent="updateItem(data.item)">
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="data.item.balancePerCardCopy"
                                placeholder="Enter Balance Per Card..."
                                class="form-control text-center"
                                :mask="currencyMask"
                            ></masked-input>
                        </form>
                    </template>
                    <template v-else>
                        <h5 class="mb-0">{{data.item.balancePerCard ? formatNumber(data.item.balancePerCard) : '-'}}</h5>
                    </template>
                </template>
                <template #cell(onHand)="data">
                    <template v-if="data.item.isUpdate">
                        <form @submit.prevent="updateItem(data.item)">
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="data.item.onHandPerCountCopy"
                                placeholder="Enter On Hand Count..."
                                class="form-control text-center"
                                :mask="currencyMask"
                            ></masked-input>
                        </form>
                    </template>
                    <template v-else>
                        <h5 class="mb-0">{{data.item.onHandPerCount ? formatNumber(data.item.onHandPerCount) : '-'}}</h5>
                    </template>
                </template>
                <template #cell(actions)="data">
                    <template v-if="data.item.isUpdate">
                        <a href="javascript:void(0);" class="text-success me-1 font-size-24" @click="$emit('update-item', data.item)" title="Update Item">
                            <i class="bx bx-check"></i>
                        </a>
                        <a href="javascript:void(0);" class="text-secondary me-1 font-size-24" @click="updateItem(data.item)" title="Cancel">
                            <i class="bx bx-x"></i>
                        </a>
                    </template>
                    <template v-else>
                        <a href="javascript:void(0);" class="text-success me-1 font-size-20" @click="beforeUpdate(data.item)" title="Update Item">
                            <i class="bx bx-edit"></i>
                        </a>
                        <a href="javascript:void(0);" class="text-danger me-1 font-size-20" @click="deleteItems([data.item])" title="Delete Item">
                            <i class="bx bx-trash"></i>
                        </a>
                    </template>
                </template>
            </b-table>
        </div>
        <div v-if="rows > perPage">
            <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0 pagination-small">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                ></b-pagination>
                </ul>
            </div>
        </div>
    </div>
</template>